import { Component } from '@angular/core';
import { IotService } from '../service/iot.service';

@Component({
    selector: 'app-mass-config',
    templateUrl: './mass-config.component.html',
    styleUrls: ['./mass-config.component.css'],
    standalone: false
})
export class MassConfigComponent {

  constructor(public iot: IotService){}

}
